import { render, staticRenderFns } from "./FormInputAmount.vue?vue&type=template&id=5bf1a80e&"
import script from "./FormInputAmount.vue?vue&type=script&lang=js&"
export * from "./FormInputAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports